import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';
import baseDefaults from '../Base/Base.defaults';
import baseTextDefaults from '../BaseText/BaseText.defaults';

export default {
  ...cloneDeep(baseDefaults),
  linkColor: 'var(--color-primary)',
  linkHoverColor: 'var(--color-primary-dark)',
  itemSpacing: {
    desktop: 8,
  },
  titleSpacing: {
    desktop: 16,
  },
  title: merge(baseTextDefaults, {
    text: `Quick Links`,
  }),
  items: [
    {
      title: 'Your number #1 benefit, right here',
      description: '',
      icon: 'check',
      action: {type: 'none'},
    },
  ],
};
